const NETWORK_ERROR_STATUS = 505;
const NETWORK_RETRY_ATTEMPTS = 1;

const isNetworkFetchError = (error: unknown) => (
  error instanceof TypeError
  || (typeof error === 'object' && error !== null && 'name' in error && (error as { name: string }).name === 'TypeError')
);

const fetchWithRetry = async (
  url: string,
  method: string,
  body: string | string[][] | Record<string, string> | {} | null,
  token: string | null,
  retriesLeft: number,
): Promise<Response> => {
  try {
    return await fetch(url, {
      method,
      body: body ? new URLSearchParams(body) : undefined,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: token ? `Bearer ${token}` : '',
      },
    });
  } catch (error) {
    if (isNetworkFetchError(error) && retriesLeft > 0) {
      // Retry once for transient browser/network transport failures.
      return fetchWithRetry(url, method, body, token, retriesLeft - 1);
    }
    if (isNetworkFetchError(error)) {
      throw NETWORK_ERROR_STATUS;
    }
    throw error;
  }
};

const fetcher = async (
  url: string,
  method: string,
  body: string | string[][] | Record<string, string> | {} | null,
  token: string| null,
) => {
  const res = await fetchWithRetry(url, method, body, token, NETWORK_RETRY_ATTEMPTS);

  if (!res) {
    throw NETWORK_ERROR_STATUS;
  }

  const response = await res.json();

  if (res.ok) {
    return { ...response, status: res.status };
  }
  if ((response as any)?.data?.message) {
    throw (response as any).data.message;
  }
  throw res.status;
};

export default fetcher;
